import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", "Your screen width was determined to be too low for this study", "Screenout", "User failed screen width check", "app.prestart.screenwidth")

